import React from 'react';
import { AiOutlineWhatsApp } from 'react-icons/ai';
import { GrFacebookOption } from 'react-icons/gr';
import { FiMail } from 'react-icons/fi';

const Share = ({ domainUrl }) => {
    return (
        <div className='mt-8 pb-8 text-center'>
            <h1  className='text-xl text-main font-bold underline' data-aos="fade-down" data-aos-easing="linear" data-aos-duration="500" data-aos-once={true} data-aos-delay="0">Share my Digicard</h1 >
            <div className='w-[160px] flex justify-around mx-auto'>
                {/* WhatsApp Share */}
                <a
                    href={`https://api.whatsapp.com/send?text=${encodeURIComponent(domainUrl)}`}
                    target="_blank"
                    className='flex flex-col justify-center items-center w-[100px] h-[100px]'
                    data-aos="fade-down" data-aos-easing="linear" data-aos-duration="500" data-aos-once={true} data-aos-delay="500"
                >
                    <div className="group flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-2 border-borderBtn hover:scale-[110%] duration-200">
                        <div className="group-hover:scale-[110%]">
                            <AiOutlineWhatsApp size={25} className='text-textBtn' />
                        </div>
                    </div>
                </a>
                {/* Facebook Share */}
                <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(domainUrl)}`}
                    target="_blank"
                    className='flex flex-col justify-center items-center w-[100px] h-[100px] '
                    data-aos="fade-down" data-aos-easing="linear" data-aos-duration="500" data-aos-once={true} data-aos-delay="550"
                >
                    <div className="group flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-2 border-borderBtn hover:scale-[110%] duration-200">
                        <div className="group-hover:scale-[110%]">
                            <GrFacebookOption size={25} className='text-textBtn' />
                        </div>
                    </div>
                </a>
                {/* Email Share */}
                <a
                    href={`mailto:?subject=כרטיס ביקור דיגיטלי&body=${encodeURIComponent(domainUrl)}`}
                    target="_blank"
                    className='flex flex-col justify-center items-center w-[100px] h-[100px] '
                    data-aos="fade-down" data-aos-easing="linear" data-aos-duration="500" data-aos-once={true} data-aos-delay="600"
                >
                    <div className="group flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-2 border-borderBtn hover:scale-[110%] duration-200">
                        <div className="group-hover:scale-[110%]">
                            <FiMail size={25} className='text-textBtn' />
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default Share;
